import { Component, HostListener, Input, Injector, QueryList, ViewChildren, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { Observable, of, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { StoreCustomFile } from '@common/models/custom-file';
import * as fromIts2Store from '@apps/its2/store';
import { IAuroraState } from '@apps/aurora.state';
import { InputBase } from '@ui/components/form/base/input-base';

import { UploadFileDisplayerComponent } from './upload-file-displayer/upload-file-displayer.component';
import { UploadFilesService } from './upload-files.service';
@Component({
    selector: 'aa-upload-files',
    templateUrl: './upload-files.component.html',
    styleUrls: [
        './upload-files.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: UploadFilesComponent,
            multi: true
        }],
    standalone: false
})
export class UploadFilesComponent extends InputBase<string> implements OnDestroy
{
    @ViewChild('input', { static: true }) inputField: HTMLElement;
    @ViewChildren(UploadFileDisplayerComponent) fileDisplayers !: QueryList<UploadFileDisplayerComponent>;
    @Input() set rfcNumber (value: string)
    {
        if (value)
        {
            this.uploadFilesService.rfcNumber = value;
        }
    }
    @Input() cta: () => any;
    @Input() prompt: string;
    @Input() height: string;
    @Input() width: string;
    @Input() allowedTypes: RegExp | string | string[];
    @Input() size: number;
    @Input() withMeta: boolean;
    @Input() maxHeight: number;
    @Input() maxWidth: number;
    @Input() autoClear: boolean = true;
    @Input()
    set allowedExt (value: RegExp | string | string[])
    {
        if (typeof value === 'string')
        {
            value = value + '$';
        }

        if (value instanceof Array)
        {
            value = value.join('|') + '$';
        }

        this._allowedExt = value;
    }
    get allowedExt (): RegExp | string | string[]
    {
        return this._allowedExt;
    }
    @Output() public filesChangeEmiter: EventEmitter<StoreCustomFile[]> = new EventEmitter();
    public dragOver: boolean = false;
    public nbFiles: Observable<number> = of(0);
    public files: Observable<StoreCustomFile[]>;
    private destroyator = new Subject();
    private _allowedExt: RegExp | string | string[];

    constructor (
        injector: Injector,
        private store: Store<IAuroraState>,
        private uploadFilesService: UploadFilesService
    )
    {
        super(injector);

        this.nbFiles = this.store.select(fromIts2Store.getTotalFiles);
        this.files = this.store.select(fromIts2Store.getAllFiles)
            .pipe(
                tap(() =>
                    this.filesChangeEmiter.emit(this.uploadFilesService.files)
                )
            );
    }

    ngOnDestroy ()
    {
        if (this.autoClear)
        {
            this.uploadFilesService.clearFiles();
        }
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    @HostListener('dragover', ['$event'])
    public onDragOver (evt: any)
    {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        this.dragOver = true;
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave (evt: any)
    {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        this.dragOver = false;
    }

    @HostListener('drop', ['$event'])
    public onDrop (evt: any)
    {
        if (evt.target && evt.target.id && evt.target.id !== 'drop-zone')
        {
            return;
        }

        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        this.dragOver = false;
        this.uploadFilesService.processFile(evt.dataTransfer.files[0]);
    }

    fileChangeEvent (fileInput: any)
    {
        if (fileInput.target.files && fileInput.target.files[0])
        {
            this.uploadFilesService.processFile(fileInput.target.files[0]);
        }
    }
}
